import { ContentLoader, useViewport } from "@bca/ui-library";

const LoadingTableRow2: React.FunctionComponent = () => {
  const viewport = useViewport();

  return (
    <tr>
      <td height={56}>
        <ContentLoader width="140px" height="24px">
          <rect width={70} height={24} rx={8} ry={8}></rect>
          <rect width={70} height={24} x={12} rx={8} ry={8}></rect>
        </ContentLoader>
      </td>
      {viewport.greaterThan.lg && (
        <td>
          <ContentLoader width="140px" height="24px">
            <rect width={60} height={24} rx={8} ry={8}></rect>
            <rect width={60} height={24} x={12} rx={8} ry={8}></rect>
          </ContentLoader>
        </td>
      )}
      <td>
        <ContentLoader width="140px" height="24px">
          <rect width={85} height={24} rx={8} ry={8}></rect>
          <rect width={85} height={24} x={12} rx={8} ry={8}></rect>
        </ContentLoader>
      </td>
      <td></td>
      {viewport.greaterThan.lg && (
        <td>
          <ContentLoader width="140px" height="24px">
            <rect width={30} height={24} rx={8} ry={8}></rect>
            <rect width={30} height={24} x={12} rx={8} ry={8}></rect>
          </ContentLoader>
        </td>
      )}
      <td>
        <ContentLoader width="140px" height="24px">
          <rect width={60} height={24} rx={8} ry={8}></rect>
          <rect width={60} height={24} x={12} rx={8} ry={8}></rect>
        </ContentLoader>
      </td>
      <td>
        <ContentLoader width="140px" height="24px">
          <rect width={50} height={24} rx={8} ry={8}></rect>
          <rect width={50} height={24} x={12} rx={8} ry={8}></rect>
        </ContentLoader>
      </td>
      <td>
        <ContentLoader width="140px" height="24px">
          <rect width={30} height={24} rx={8} ry={8}></rect>
          <rect width={30} height={24} x={12} rx={8} ry={8}></rect>
        </ContentLoader>
      </td>
    </tr>
  );
};

export default LoadingTableRow2;
